import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { Hook } from './components/Hook';
import { Pain } from './components/Pain';
import { Revelation } from './components/Revelation';
import { Testimonials } from './components/Testimonials';
import { Offer } from './components/Offer';
import { FAQ } from './components/FAQ';
import { Guarantee } from './components/Guarantee';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { initMetaPixel, trackPageView, trackViewContent } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
    trackViewContent();
  }, []);
  return <main className="min-h-screen bg-cream" data-id="element-0">
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1299609178999376&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <Hero data-id="element-3" />
      <Hook data-id="element-4" />
      <Pain data-id="element-5" />
      <Revelation data-id="element-6" />
      <Testimonials data-id="element-7" />
      <Offer data-id="element-8" />
      <FAQ data-id="element-9" />
      <Guarantee data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <Footer data-id="element-12" />
      <PurchaseNotifications data-id="element-13" />
    </main>;
}